import { render, staticRenderFns } from "./NewUserOnboarding.vue?vue&type=template&id=6a22cabb&scoped=true&"
import script from "./NewUserOnboarding.vue?vue&type=script&lang=js&"
export * from "./NewUserOnboarding.vue?vue&type=script&lang=js&"
import style0 from "./NewUserOnboarding.vue?vue&type=style&index=0&id=6a22cabb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a22cabb",
  null
  
)

export default component.exports